<template>
  <b-row class="px-2 mt-3">
    <b-col lg="12" class="mb-3 mb-lg-0 d-flex">
      <iq-card class="fuel-card h-100 w-100">
        <div class="iq-card-body" style="padding: 15px 20px;">
          <div class="fms-card-header">
            <div>
              <h4>Flow Rate Trend</h4>
              <p class="text-muted">All flow rate over the last 24 hours.</p>
            </div>
            <span class="fms-tag fms-tag--outline">24H Window</span>
          </div>
          <b-row>
            <b-col
              v-for="block in flowmeterBlocks"
              :key="block.name"
              :lg="block.charts.length === 2 ? 12 : 6"
              class="px-2"
            >
              <!-- in-out -> 2 chart sebaris (berdampingan); single -> 1 chart penuh -->
              <b-row class="mx-0">
                <b-col
                  v-for="meter in block.charts"
                  :key="meter.id"
                  :lg="block.charts.length === 2 ? 6 : 12"
                  class="px-1"
                >
                  <flow-rate-chart
                    :series="meter.series"
                    :seriesKey="meter.seriesKey"
                    :side="meter.side"
                    :title="meter.title"
                    :avgFlow="meter.avgFlow"
                    :engineCons="meter.engineCons"
                    :currentFlowrate="meter.current?.flowrate"
                    :currentDensity="meter.current?.density"
                    :currentTemp="meter.current?.temp"
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </iq-card>
    </b-col>
  </b-row>
</template>

<script>
import { prettyLabel } from '@/util/ship/vesselDetail';
import FlowRateChart from '../charts/FlowrateChart';

export default {
  name: 'FlowRateTrendCard',
  components: {
    FlowRateChart,
  },
  props: {
    currAssetSummary: {
      type: Object,
      required: true,
    },
    currAssetLastData: {
      type: Object,
      default: null,
    },
    deviceStatus: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    flowmeterBlocks() {
      const blocks = [];
      const { fm, series } = this.currAssetSummary || {};
      const groups = this.deviceStatus?.flowmeterGroups || [];
      const lastFm = this.currAssetLastData?.fm || {};

      if (!fm || !series) return [];

      // `side` cuma buat warna chart; nama group bebas (AE4, AE_INLINE, ...) -> fallback 'port'.
      const safeSide = (name) => (['port', 'starboard', 'center'].includes(name.toLowerCase())
        ? name.toLowerCase()
        : 'port');

      const makeMeter = (name, dir, dirData) => {
        const labelKey = `${name}_${dir}`; // PORT_IN, AE_INLINE_OUT, ...
        return {
          id: labelKey,
          title: `${prettyLabel(labelKey)} Flow Rate`,
          side: safeSide(name),
          series,
          seriesKey: labelKey,
          avgFlow: dirData.avgFuelFlow,
          engineCons: dirData.engineCons,
          current: lastFm[labelKey],
        };
      };

      // Satu group = satu blok; in & out dikumpulin biar bisa dirender berdampingan.
      groups.forEach((group) => {
        const groupData = fm[group.name];
        if (!groupData) return;
        const charts = [];
        if (groupData.in) charts.push(makeMeter(group.name, 'IN', groupData.in));
        if (groupData.out) charts.push(makeMeter(group.name, 'OUT', groupData.out));
        if (charts.length) blocks.push({ name: group.name, charts });
      });

      // Single (1 chart) duluan, pair in-out (2 chart) belakangan -> pair sebaris penuh,
      // single nggak ninggalin celah setengah baris.
      blocks.sort((a, b) => a.charts.length - b.charts.length);

      return blocks;
    },
  },
};
</script>

<style scoped>
.fuel-section {
  margin-top: 12px;
  padding: 12px;
  border: 2px solid #E8ECF3;
  border-radius: 20px;
}
</style>
